export default "__VITE_ASSET__DGa3hlpD__"